import React from 'react';
import PropTypes from 'prop-types';

import Header from './header';
import Footer from './footer';
import request, { USER_RIGHTS } from '../utils/request';

const Layout = ({ locale, children }) => {
  const { getProfile } = request;
  const profile = getProfile();
  const userName = profile
    ? `${profile.firstName} ${profile.lastName}`
    : undefined;
  const userRights = profile ? USER_RIGHTS[profile.role.name] : undefined;
  return (
    <>
      <Header
        locale={locale}
        userName={userName}
        userRights={userRights}
        profile={profile}
      />
      <div className="layout-container">{children}</div>
      <Footer disclaimer={false} />
    </>
  );
};

Layout.propTypes = {
  locale: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default Layout;
